import React, { Component } from 'react';
import bookmark from '../../Images/Icons/bookmark.png';
import bookmark_on from '../../Images/Icons/bookmark_on.png';
import AC1 from '../../Images/Daikin_Images/icon/AC1.png';
import temp from '../../Images/Daikin_Images/icon/temp.png';
import { getIcon, isEmpty } from '../Common/Common';

import communication_error_icon from '../../Images/Daikin_Images/image/CommError.png';
import device_error_icon from '../../Images/Daikin_Images/image/Error.png';

export default class Group_Cell extends Component {
	constructor(props) {
		super(props);
		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list != null) {
			if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
				bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username]
			}
		}

		if (bookmark_list.group == null || bookmark_list.group == undefined) {
			bookmark_list.group = [];
		}

		let is_bookmark = false;

		if (bookmark_list.group.length > 0 && bookmark_list.group.includes(this.props.id)) {
			is_bookmark = true;
		}

		this.are_devices_on = false;
		this.temperature_value = '';
		this.sensorLighting_unit = '';
		this.sensorLighting_value = '';
		this.sensorLighting_display = '';
		this.displayCommunicationErrorIcon = false;
		this.displayDeviceErrorIcon = false;

		this.state = {
			is_bookmark: is_bookmark,
			is_cell_focused: false,
		}

		this.handleRetrieveValues();
		this.handleCheckAllDeviceStatus();
	}

	handleSelectGroup = () => {
		document.getElementById('carousel_' + this.props.id + '_cell_external').classList.remove('flipInY');
		document.getElementById('carousel_' + this.props.id + '_cell_external').classList.add('fadeIn');
		setTimeout(() => {
			if (document.getElementById('carousel_' + this.props.id + '_cell_external') != null) {
				document.getElementById('carousel_' + this.props.id + '_cell_external').classList.remove('fadeIn');
			}
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			// Retain scroll position of groups screen
			this.props.content_handler('Group_Details', { group_info: this.props.group_info, group_id: this.props.id, from: this.props.from, groups: this.props.groups, groups_scroll_top: this.props.groups_scroll_top });
		}, 300);

	}

	handleToggleBookmark = (e) => {
		e.stopPropagation();
		let is_bookmark = !this.state.is_bookmark;
		this.setState({ is_bookmark: is_bookmark });

		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list == null) {
			controller_info.bookmark_list = {};
			controller_info.bookmark_list[this.props.receiver.active_controller.username] = {};
		} else if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
			bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username];
		}

		if (bookmark_list.group == null || bookmark_list.group == undefined) {
			bookmark_list.group = [];
		}

		if (is_bookmark && !bookmark_list.group.includes(this.props.id)) {
			bookmark_list.group.push(this.props.id);
		} else if (!is_bookmark && bookmark_list.group.includes(this.props.id)) {
			bookmark_list.group.splice(bookmark_list.group.indexOf(this.props.id), 1);
		}

		controller_info.bookmark_list[this.props.receiver.active_controller.username] = bookmark_list;
		window.localStorage.setItem(this.props.receiver.active_controller.name, JSON.stringify(controller_info));
	}

	// Added this method to retrieve temperature value and sensor/lighting value
	handleRetrieveValues = () => {
		//1. Check temperature value and sensor or lighting value in the group
		//2. If applicable, display information accordingly
		if (!isEmpty(this.props.group_info)) {
			if (this.props.group_info.hasOwnProperty('temp_targ')) {
				let temperatureDevice = this.props.group_info.temp_targ;  //temperature value of group
				// Make sure that the temp target must be in the group
				if (this.props.group_info.mp.includes(temperatureDevice)) {
					let temp_targ_info = window.app.state.point_list[temperatureDevice];
					if (!isEmpty(temp_targ_info)) {
						if (temp_targ_info.comm_stat) { //if there is no communication error for management point
							if (temp_targ_info.type == 'Ac') {
								this.temperature_value = temp_targ_info.temp + this.props.receiver.getString('DEG'); //temperature
							}
							else if (temp_targ_info.type == 'Value') {
								this.temperature_value = temp_targ_info.av + this.props.receiver.getString('DEG'); //av
							}
						}
					}
				}
			}

			if (this.props.group_info.hasOwnProperty('value_targ')) {
				let sensorLightingDevice = this.props.group_info.value_targ; //sensor or lighting value of group
				// Make sure that the value target must be in the group
				if (this.props.group_info.mp.includes(sensorLightingDevice)) {
					let value_targ_info = window.app.state.point_list[sensorLightingDevice];
					if (!isEmpty(value_targ_info)) {
						if (value_targ_info.comm_stat) { //if there is no communication error for management point
							this.sensorLighting_unit = value_targ_info.unit; // unit 
							this.sensorLighting_value = value_targ_info.av; //av value
							if (this.sensorLighting_unit != null) { //if there is no unit for this management point
								this.sensorLighting_display = this.sensorLighting_value + " " + this.props.receiver.getString(this.sensorLighting_unit);
							} else {
								this.sensorLighting_display = this.sensorLighting_value;
							}
						}
					}
				}
			}
		}

	}

	// Added this method to check if at least one device has stat = on
	handleCheckAllDeviceStatus = () => {
		//1. Check all devices in the group
		//2. If at least one device has a communication error - display communication error icon
		//3. If the device has a communication error, ignore device's stat 
		//4. If all devices are switched off, backgroundImage should be null
		//5. If at least one device is on and no communication error, backgroundImage should display gradient
		let are_devices_on = false;
		let displayDeviceErrorIcon = false;
		let displayCommunicationErrorIcon = false;

		if (!isEmpty(this.props.group_info)) {
			let groupName = this.props.group_info.name; //name of the management group
			let groupManagementPoints = this.props.group_info.mp; //the management points in the group
			if (groupManagementPoints != null) {
				for (let point_id of groupManagementPoints) { //for each management point in the group
					let point_info = window.app.state.point_list[point_id];
					if (point_info != null) {
						let mpName = point_info.name; //management point name
						if (point_info.hasOwnProperty('comm_stat')) {
							let communication_status = point_info.comm_stat;
							if (communication_status) { //if management point doesnt have any communication error
								if (point_info.hasOwnProperty('stat')) {
									let mpStatus = point_info.stat; //management point status
									if (mpStatus === 'on') { //if management point status is on
										are_devices_on = true;
									}
								} else {
									//Management point cannot be switched on/off
									//Display icon as off
								}
							} else {
								//management point has a communication error
								//display communication error icon
								displayCommunicationErrorIcon = true;
							}
						}

						if (point_info.hasOwnProperty('error')) {
							let deviceError = point_info.error;
							for (var key in deviceError) { //check every jsonObject in error
								if (deviceError[key]) { //check value of the jsonObject is true 
									displayDeviceErrorIcon = true;
								}
							}
						} else if (point_info.hasOwnProperty('alert')) {
							let device_alert = point_info.alert;
							for (var key in device_alert) { //check every jsonObject in error
								if (device_alert[key]) { //check value of the jsonObject is true 
									displayDeviceErrorIcon = true;
								}
							}
						}
					}
				}
			}
		}

		if (displayCommunicationErrorIcon != this.displayCommunicationErrorIcon) {
			this.displayCommunicationErrorIcon = displayCommunicationErrorIcon;
		}

		if (displayDeviceErrorIcon != this.displayDeviceErrorIcon) {
			this.displayDeviceErrorIcon = displayDeviceErrorIcon;
		}

		if (are_devices_on != this.are_devices_on) {
			this.are_devices_on = are_devices_on;
		}
	}

	render() {
		let style = {
			display: 'inline-block',
			verticalAlign: 'top'
		}

		let cell_width = 145;

		let cell_style = {
			cursor: 'pointer',
			width: cell_width,
			height: 100,
			margin: 5,
			padding: 10,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			cursor: 'pointer',
		}

		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';
		let temp_val = '';
		let value_val = '';

		this.handleRetrieveValues();
		this.handleCheckAllDeviceStatus();

		let has_accessible_points = true;
		let group_points = this.props.group_info.mp; //list of management points in a group
		let accessible_points = this.props.receiver.active_controller.auth.points; //list of points user has/has no access to

		if (this.props.receiver.active_controller.user_class != 'Admin') { //Admin class has access to all MP, so do not have to check
			has_accessible_points = false;
			if (group_points != null) {
				for (let j = 0; j < group_points.length; j++) {
					if (accessible_points.hasOwnProperty(group_points[j])) {
						if (accessible_points[group_points[j]]) {
							has_accessible_points = true;
							break;
						}
					}
				}
			}
		}

		let icon = getIcon(this.props.group_info.icon);
		if (has_accessible_points) {
			return (
				<div style={style} id={'carousel_' + this.props.id + '_cell_external'} className={this.state.is_cell_focused ? 'flipOutY' : 'flipInY'}>
					<div id={'carousel_' + this.props.id + '_cell_internal'} style={cell_style} onClick={this.handleSelectGroup}>
						<div id='carousel_4'>
							<div id='carousel_5' style={{ display: 'inline-block', width: 25 }}>
								<img src={this.state.is_bookmark ? bookmark_on : bookmark} style={{ cursor: 'pointer', width: 25, }} onClick={this.handleToggleBookmark} />
							</div>
							<div id='carousel_6' style={{ textAlign: 'left', display: 'inline-block', width: cell_width - 30, marginLeft: 5, marginfRight: 5, verticalAlign: 'top', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
								<span style={{ overflow: 'hidden', display: 'block', width: '90%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: 12 }}> {this.props.receiver.getString(this.props.group_info.name)} </span>
							</div>
						</div>

						<div id='carousel_8' style={{ textAlign: this.sensorLighting_value != '' || this.temperature_value != '' ? 'left' : 'center' }}>
							<div id='carousel_9' style={this.are_devices_on ?
								{ textAlign: 'center', marginLeft: -5, width: 70, height: 70, display: 'inline-block', backgroundImage: background_gradient, borderRadius: 35 } :
								{ textAlign: 'center', marginLeft: -5, width: 70, height: 70, display: 'inline-block', backgroundImage: null, borderRadius: 35 }}>
								<img src={icon} style={{ width: 40, opacity: 0.6, paddingTop: 15 }} />
								<div style={{ position: 'absolute' }}>
									<img src={communication_error_icon} style={{ width: 20, position: 'absolute', top: -50, left: 5, visibility: this.displayCommunicationErrorIcon ? 'visible' : 'hidden' }} />
									<img src={device_error_icon} style={{ width: 20, position: 'absolute', top: this.displayCommunicationErrorIcon ? -25 : -50, left: 5, visibility: this.displayDeviceErrorIcon ? 'visible' : 'hidden' }} />
								</div>
							</div>

							<div id='carousel_10' style={{ marginLeft: -10, display: 'inline-block', verticalAlign: 'top', paddingTop: 10 }}>
								<div id='carousel_11' style={{ display: this.temperature_value == '' ? 'none' : 'block' }}>
									<div style={{ marginLeft: -5, display: 'inline-block' }}>
										<img src={temp} style={{ width: 25 }} />
									</div>
									<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
										<span style={{ fontSize: 14 }}>{this.temperature_value}</span>
									</div>
								</div>

								<div id='carousel_12' style={{ display: this.sensorLighting_display == '' ? 'none' : 'block', marginTop: -5 }}>
									<span style={{ fontSize: 14 }}>{this.sensorLighting_display}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}